/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TimeLeftIcon {
  None = 'None',
  Warning = 'Warning',
  Error = 'Error'
}
